const navbar = document.getElementById('pageheader')

// OnScroll event handler
const onScroll = () => {

  // Get scroll value
  const scroll = document.documentElement.scrollTop

  // If scroll value is more than 0 - add class
  if (scroll > 0) {
    navbar.classList.add("is-sticky");
  } else {
    navbar.classList.remove("is-sticky")
  }
}

// Optional - throttling onScroll handler at 100ms with lodash
// const throttledOnScroll = _.throttle(onScroll, 100, {})

// Use either onScroll or throttledOnScroll
window.addEventListener('scroll', onScroll)
